import Modal from "@/components/core/Modal/Modal"
import ReactStars from "react-rating-stars-component"
import HalfStar from "@/public/icons/half-star.svg"
import EmptyStar from "@/public/icons/empty-star.svg"
import WhiteStar from "@/public/icons/white-star.svg"
import Input from "@/components/core/Input/Input"
import TextArea from "@/components/core/TextArea/TextArea"

import { useState } from "react"
import Button from "@/components/core/Button/Button"
import { validateField } from "@/utils/helper"
import { validText } from "@/utils/validate"
import {
  reviewFieldClickAnalytics,
  submitReviewAnalytics,
} from "@/components/Review/v1/analytics"
import { postProductReview } from "@/store/features/pdpSlice"
import { useDispatch, useSelector } from "react-redux"
import { selectAuthState } from "@/store/features/authSlice"

const ReviewModal = props => {
  const {
    showModal,
    closeModal,
    ratingValue,
    setRatingValue,
    productId,
    setSuccess,
    productName,
    setIsOpen,
  } = props
  const [data, setData] = useState({})
  const [error, setError] = useState({})
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()
  const { isAuth, user } = useSelector(selectAuthState)
  const validateExist = field => {
    if (field === "review") {
      if (!data?.[field]?.trim()) {
        return "Please Enter Review"
      } else if (data?.[field]?.length < 50)
        return "Please enter at least 50 characters"
      else return ""
    } else if (field === "reviewTitle") {
      if (!data?.[field]?.trim()) {
        return "Please Enter Review Title"
      } else return ""
    }
  }

  const handleChange = (e, name) => {
    const { value } = e.target
    if (value === "" || value.length) {
      setData({
        ...data,
        [name]: value,
      })
      if (name === "reviewTitle")
        if (value === "")
          setError({
            ...error,
            [name]: "Please Enter Review Title",
          })
        else
          setError({
            ...error,
            [name]: "",
          })
      else if (name === "review") {
        if (value === "") {
          setError({
            ...error,
            [name]: "Please Enter Review",
          })
        } else if (value.length < 50) {
          setError({
            ...error,
            [name]: "Please enter at least 50 characters",
          })
        } else
          setError({
            ...error,
            [name]: "",
          })
      }
    }
  }
  const onBlur = field => {
    setError({
      ...error,
      [field]: validateExist(field),
    })
  }
  const getErrorList = () => {
    const errorList = {
      review: validateExist("review"),
      reviewTitle: validateExist("reviewTitle"),
    }
    return errorList
  }
  const handleSubmit = () => {
    setLoading(true)
    const authorName = isAuth ? `${user.firstName} ${user.lastName}` : "Guest"
    const customerId = isAuth ? user.commercetoolsID : ""
    dispatch(
      postProductReview({
        authorName: authorName,
        title: data?.reviewTitle,
        text: data?.review,
        rating: ratingValue,
        productId: productId,
        ...(customerId !== "" && {
          customerId: customerId,
        }),
      })
    )
      .then(response => {
        if (response?.payload?.status === 200) {
          setSuccess(true)
          setLoading(false)
          submitReviewAnalytics()
          setIsOpen(false)
          setRatingValue(0)
        } else {
          setSuccess(false)
          closeModal()
          setLoading(false)
        }
      })
      .catch(err => {
        setLoading(false)
        console.log(err)
      })
  }
  const isEnabled = Object?.values(getErrorList())?.find(el => el)
    ? true
    : false
  const handleFocus = name => {
    reviewFieldClickAnalytics(name)
  }
  const productRating = () => {
    if (ratingValue === 5) return "Excellent"
    else if (ratingValue === 4) return "Good"
    else if (ratingValue === 3) return "Average"
    else if (ratingValue === 2) return "Fair"
    else if (ratingValue === 1) return "Poor"
  }
  return (
    <>
      <Modal showModal={showModal} onModalClose={closeModal}>
        <div className="review-modal">
          <div className="title">My Review</div>
          <div className="product-heading">{productName}</div>
          <div className="title">Required fields are marked with *</div>
          <div className="overall-rating">Overall Rating</div>
          <ReactStars
            count={5}
            size={24}
            emptyIcon={<img src={EmptyStar.src} className="empty-reviews" />}
            halfIcon={<img src={HalfStar.src} />}
            filledIcon={<img src={WhiteStar.src} className="filled-reviews" />}
            onChange={rating => setRatingValue(rating)}
            value={ratingValue}
          />
          <div className="title">{`${ratingValue} out of 5 stars selected. Product is ${productRating()}`}</div>
          <div className="review-title-heading">Review Title*</div>
          <div className="review-title-input">
            <Input
              type="text"
              value={data?.reviewTitle}
              name="reviewTitle"
              label="Example: Great Features"
              onChange={e => handleChange(e, "reviewTitle")}
              maxLength={50}
              customClass="review-title-input"
              onBlur={() => onBlur("reviewTitle")}
              showError={error?.reviewTitle !== "" && error?.reviewTitle}
              errorMessage={error?.reviewTitle}
              onFocus={() => handleFocus("reviewTitle")}
              hideLabelOnFocus={true}
            />
          </div>
          <div className="review-title-heading">Review*</div>
          <div className="review-title-input  resizable">
            <TextArea
              name="review"
              label="Example: I bought this a month and....."
              placeholder="Example: I bought this a month and....."
              value={data?.review}
              onChange={e => handleChange(e, "review")}
              customClass="review-title-input resizable"
              onBlur={() => onBlur("review")}
              showError={error?.review !== "" && error?.review}
              errorMessage={error?.review}
              onFocus={() => handleFocus("review")}
              hideLabelOnFocus={true}
            />
          </div>
          <Button
            label="Submit"
            className="submit-cta"
            type="black"
            size="large"
            role="button"
            disabled={isEnabled}
            onClick={handleSubmit}
            loading={loading}
          />
        </div>
      </Modal>
    </>
  )
}
export default ReviewModal
